import React from 'react';
import styles from "./card-authors.module.css";
/** Props for `CardAuthors` component */

/**
 * ### CardAuthors
 *
 * Renders the authors, creators, or attribution for a card. Content can
 * include a single or multiple authors.
 */
export const CardAuthors = _ref => {
  let {
    label,
    authors
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.authors
  }, label && /*#__PURE__*/React.createElement("span", {
    className: "ud-sr-only"
  }, label), authors);
};
//# sourceMappingURL=card-authors.react-component.js.map